import React, { Component, } from 'react';
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  ZAxis,
  CartesianGrid,
  Cell,
  Tooltip,
  Legend,
} from 'recharts';
import keys from 'lodash/keys';
import Return from '../../../legacy-tv-ui/Return';
import { color, } from '../../../legacy-tv-dls';
import { toPercentage, } from '../../../utils';

const INTERVAL_MAP = {
  '1M': '_1m',
  '3M': '_3m',
  '6M': '_6m',
  '1Y': '_12m',
  'YTM': 'YTM',
};
const ASSET_CLASS_COLOR = {
  Equity: color.sector.red,
  Commodity: color.sector.blue,
  Bond: color.sector.yellow,
};

export default class ReturnVol extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSymbolMap: {},
      assetClass: {
        Equity: [],
        Commodity: [],
        Bond: [],
      },
    };
  }
  handleResize = () => {
    // setTimeout(() => {
    //   this.setState({
    //     width: document.getElementById('scatter-chart-container').offsetWidth,
    //   });
    // }, 0);
  };
  updateChartData = (props) => {
    const {
      symbolDetail,
      selectedIds,
      allIds,
      interval,
    } = props;
    const newAssetClass = {
      Equity: [],
      Bond: [],
      Commodity: [],
    };
    const selectedSymbolMap = selectedIds.reduce((pre, cur) => {
      pre[symbolDetail[cur].name] = true;
      return pre;
    }, {});
    let allSymbol = allIds.map((id) => {
      if (!symbolDetail[id]) return null;
      return {
        assetClass: symbolDetail[id].asset_class,
        name: symbolDetail[id].name,
        Return: symbolDetail[id][INTERVAL_MAP[interval]].rtn,
        Vol: symbolDetail[id][INTERVAL_MAP[interval]].vol,
        id: 10,
      };
    });
    allSymbol = allSymbol.filter(d => d);
    allSymbol.forEach((elem) => {
      newAssetClass[elem.assetClass].push(elem);
    });
    this.setState({
      selectedSymbolMap,
      assetClass: newAssetClass,
    });
  }
  componentWillReceiveProps(nextProps) {
    this.updateChartData(nextProps);
  }
  componentDidMount() {
    this.updateChartData(this.props);
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  render() {
    return (
      <div id="scatter-chart-container">
        <ScatterChart
          width={960}
          height={400}
          margin={{
            top: 20, right: 20, bottom: 20, left: 20,
          }}
        >
          <CartesianGrid />
          <XAxis
            dataKey="Vol"
            type="number"
            name="Vol"
            label={{ value: 'Volitility', position: 'insideBottomRight', offset: -20, }}
          />
          <YAxis
            dataKey="Return"
            type="number"
            name="Return"
            label={{ value: 'Return', angle: -90, position: 'insideLeft', }}
          />
          <ZAxis dataKey="id" range={[64, 144, undefined]} name="id" unit="" />
          <Legend />
          <Tooltip
            cursor={{ strokeDasharray: '3 3', }}
            formatter={(value, name, props) => {
              if (name === 'id') {
                return (
                  <div
                    style={{ color: ASSET_CLASS_COLOR[props.payload.assetClass], }}
                  >
                    {props.payload.name}
                  </div>
                );
              } else if (name === 'Return') {
                return <Return style={{ display: 'inline', }} rtn={value} />;
              }
              return <div>{toPercentage(value)}</div>;
            }}
          />
          {
            keys(this.state.assetClass).map(c => (
              <Scatter
                key={c}
                name={c}
                data={this.state.assetClass[c]}
                fill={ASSET_CLASS_COLOR[c]}
                // shape="star"
                shape={
                  (...args) => {
                    const {
                      x, y, width, assetClass, name,
                    } = args[0];
                    const opacity = this.state.selectedSymbolMap[name] ? 0.8 : 0.15;
                    return (
                      <circle
                        onMouseEnter={(e) => {
                          e.target.originalOpacity = e.target.style.fillOpacity;
                          e.target.style.fillOpacity = 1;
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.fillOpacity = e.target.originalOpacity;
                        }}
                        fill={ASSET_CLASS_COLOR[assetClass]}
                        fillOpacity={opacity}
                        cursor="pointer"
                        cx={x + (width / 2)}
                        cy={y + (width / 2)}
                        r={width * 1.3}
                      />
                    );
                  }
                }
              >
                {
                  this.state.assetClass[c].map((entry) => {
                    const opacity = this.state.selectedSymbolMap[entry.name] ? 1 : 0.18;
                    return (
                      <Cell
                        key={entry.name}
                        fill={ASSET_CLASS_COLOR[c]}
                        fillOpacity={opacity}
                      />
                    );
                  })
                }
              </Scatter>
            ))
          }
        </ScatterChart>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/scenes/SymbolSummary/components/ReturnVol.js